// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageSkeleton-moduleEmailProfileMessageSkeleton__qVi2x EmailProfileMessage-moduleEmailProfileMessage__AFktx";
export { _1 as "EmailProfileMessageSkeleton" }
